'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { useMemo } from 'react';
import { getChainInfo, isBitcoinConnector } from '@dynamic-labs/wallet-connector-core';
import { WalletAddressType } from '@dynamic-labs/sdk-api-core';
import { getWalletAdditionalAddressByType } from '../../../utils/functions/getWalletAdditionalAddressByType/getWalletAdditionalAddressByType.js';
import { usePromise } from '../../../utils/hooks/usePromise/usePromise.js';
import { getOnrampProviders } from '../../../data/api/onramp/onramp.js';

const useEnabledOnrampProviders = ({ primaryWallet, network, environmentId, projectSettingsOnramps, target, }) => {
    var _a;
    const chainName = (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain)
        ? (_a = getChainInfo(primaryWallet.chain)) === null || _a === void 0 ? void 0 : _a.name
        : undefined;
    const bitcoinAddress = primaryWallet &&
        isBitcoinConnector(primaryWallet.connector) &&
        getWalletAdditionalAddressByType(WalletAddressType.Payment, primaryWallet);
    const chainHasNetwork = network && chainName === 'evm';
    const { data: onrampProviders } = usePromise(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!chainName || !(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address))
            return [];
        return getOnrampProviders({
            chain: chainName,
            environmentId,
            networkId: chainHasNetwork ? network.toString() : undefined,
            token: target.token,
            walletAddress: target.address || bitcoinAddress || primaryWallet.address,
        });
    }), {
        deps: [
            environmentId,
            network,
            primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address,
            target.address,
            target.token,
        ],
        initialData: [],
    });
    return useMemo(() => onrampProviders.filter((p) => projectSettingsOnramps === null || projectSettingsOnramps === void 0 ? void 0 : projectSettingsOnramps.includes(p.provider)), [onrampProviders, projectSettingsOnramps]);
};

export { useEnabledOnrampProviders };
